/**
 * Maps the installment table returned by GET payments/methods into the
 * { value, label, interest } shape the credit card / Muvicard installment
 * selects already expect.
 * @param {Array} installments [{ count, interestRate, installmentAmount, totalAmount }]
 * @param {number} orderValue The order's total value (used to compute interest)
 * @param {object} options
 * @param {boolean} options.showAVista Show "à vista" for the first (1x) option
 */
export function mapApiInstallments(installments = [], orderValue = 0, { showAVista = false } = {}) {
	// Reteste 2 (O1): os juros são medidos contra o total À VISTA da própria grade (1x sem juros), que já traz o desconto
	// do meio (ex.: 10% da 1ª compra Muvicard). Contra o valor do pedido sem desconto, o desconto virava "juros negativos".
	// O desconto fica separado (`discount`); sem a opção à vista na grade, vale o valor do pedido.
	const cashOption = installments.find((item) => item.count === 1 && !(item.interestRate > 0))
	const base = cashOption ? cashOption.totalAmount : orderValue

	return installments.map((item, index) => {
		const installmentValue = item.installmentAmount.$toReais()
		const hasInterest = item.interestRate > 0
		const interest = Math.max(0, Math.round((item.totalAmount - base) * 100) / 100)
		const discount = Math.max(0, Math.round((orderValue - base) * 100) / 100)

		const label =
			showAVista && index === 0
				? `${installmentValue} à vista`
				: `${item.count}x de
						${installmentValue} ${
							hasInterest ? '(Juros: ' + interest.$toReais() + ')' : ' sem juros'
					  }
						 `

		return {
			value: item.count,
			label,
			interest,
			// Desconto do meio de pagamento já aplicado no total desta grade (≥ 0; a 1ª compra Muvicard, por exemplo).
			discount,
			// Total que o servidor cobra com esta quantidade de parcelas (juros e descontos do fechamento já dentro).
			totalAmount: item.totalAmount,
		}
	})
}
